import { createAction, props } from '@ngrx/store';

export const SetLoadingSpinner = createAction(
  '[Shared: Progress]: Set Loading Spinner',
  props<{ showSpinner: boolean }>(),
);

export const SetLoadingBar = createAction('[Shared: Progress]: Set Loading Bar', props<{ showBar: boolean }>());

export const SetSearchSpinner = createAction(
  '[Shared: Progress]: Set Search Spinner',
  props<{ showSearchSpinner: boolean }>(),
);

export const IncrementLoadRequests = createAction('[Shared: Progress]: Increment Load Requests');

export const IncrementActionRequests = createAction('[Shared: Progress]: Increment Action Requests');

export const IncrementSearchRequests = createAction('[Shared: Progress]: Increment Search Requests');

export const DecrementLoadRequests = createAction('[Shared: Progress]: Decrement Load Requests');

export const DecrementActionRequests = createAction('[Shared: Progress]: Decrement Action Requests');

export const DecrementSearchRequests = createAction('[Shared: Progress]: Decrement Search Requests');
